var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.43c-1.78 0-3.51.52-5.09 1.49-1.58.98-3 2.41-4.16 4.23-1 1.57-1 4.12 0 5.69 2.31 3.64 5.69 5.72 9.25 5.72 1.78 0 3.51-.52 5.09-1.49 1.58-.98 3-2.41 4.16-4.23 1-1.56 1-4.12 0-5.69-2.31-3.63-5.69-5.72-9.25-5.72zM7.96 12c0-2.23 1.8-4.04 4.04-4.04s4.04 1.81 4.04 4.04-1.8 4.04-4.04 4.04S7.96 14.23 7.96 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.148 12c0 1.57 1.28 2.85 2.85 2.85s2.86-1.28 2.86-2.85-1.29-2.86-2.86-2.86c-1.57 0-2.85 1.28-2.85 2.86z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldEye);
export default __webpack_public_path__ + "static/media/vuesax-bold-eye.b3a17832b2911f7f9f094a0c4f5844ca.svg";
export { ForwardRef as ReactComponent };